import { Radio, RadioGroup } from "@design-system/Radio/Radio";
import styles from "./ReviewFilter.module.scss";

interface ModeOption<T extends string> {
    value: T;
    label: string;
}

interface Props<T extends string> {
    name: string;
    value: T;
    options: Array<ModeOption<T>>;
    onChange: (value: T) => void;
}

export const ModeRadioGroup = <T extends string>({
    name,
    value,
    options,
    onChange,
}: Props<T>) => (
    <RadioGroup
        name={name}
        aria-label={name}
        value={value}
        onValueChange={onChange}
        className={styles.modeSection}
    >
        {options.map((option) => (
            <Radio
                key={option.value}
                value={option.value}
                label={option.label}
            />
        ))}
    </RadioGroup>
);
